import { get, putJson, postJson, del } from '../httpClient';

/**
 * Client for /api/creator/configurations + /api/creator/sender-domain.
 *
 * Self-scoped — server derives identity from the authenticated SDK
 * session. Returned `config` always contains every supported key with
 * a default value filled in for the unset ones.
 */
export const creatorConfigurationsAPI = {
  /** GET /api/creator/configurations */
  getConfig: () => get('/api/creator/configurations'),

  /** PUT /api/creator/configurations — body: { config: { … } } */
  updateConfig: config => putJson('/api/creator/configurations', { config }),

  // ── Sender domain ──
  /** GET current sender-domain state */
  getSenderDomain: () => get('/api/creator/sender-domain'),
  /** POST connect a domain → returns CNAME records to add to DNS */
  connectSenderDomain: domain => postJson('/api/creator/sender-domain', { domain }),
  /** POST validate DNS */
  verifySenderDomain: () => postJson('/api/creator/sender-domain/verify', {}),
  /** PUT set the from-address (must be @ the verified domain) */
  setSenderFromEmail: fromEmail => putJson('/api/creator/sender-domain/from', { fromEmail }),
  /** DELETE disconnect the domain */
  disconnectSenderDomain: () => del('/api/creator/sender-domain'),
};
